
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M11.5 2.51316V12V12.5H12H21.4868C21.3971 14.2034 20.85 15.8546 19.899 17.2779C18.8551 18.8402 17.3714 20.0578 15.6355 20.7769C13.8996 21.4959 11.9895 21.684 10.1466 21.3175C8.30383 20.9509 6.61109 20.0461 5.28249 18.7175C3.95389 17.3889 3.0491 15.6962 2.68254 13.8534C2.31598 12.0105 2.50412 10.1004 3.22315 8.36451C3.94218 6.62861 5.15982 5.14491 6.72209 4.10104C8.14545 3.14998 9.79665 2.60292 11.5 2.51316Z"></path><path d="M13.5 2.51472C14.4453 2.57042 15.3758 2.78376 16.2528 3.14702C17.2841 3.57419 18.2211 4.2003 19.0104 4.98959C19.7997 5.77889 20.4258 6.71593 20.853 7.74719C21.2162 8.62419 21.4296 9.55473 21.4853 10.5L13.5 10.5L13.5 2.51472Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiPie",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
